<template lang="jade">
  .container-fluid.clearfix
    .mask(v-if='showMask')
      h2 Please rotate your mobile to show config
    .row
      .layout_main.col-md-12
        header.layout_title_bar.main_title_bar.clearfix
          h1.title.col-lg-10.col-md-10.col-sm-10.col-xs-10 Layout
          v-loader.col-lg-2.col-lg-offset-3.col-md-2.col-md-offset-3.col-sm-1.col-sm-offset-3.col-xs-2.col-xs-offset-0(
            v-bind:ani-key="'6'"
            v-if="isFetching"
          )
          .function_group.col-xs-4.col-md-4.pull-right
            .col-xs-4.no_pad-xs.clearfix.function__single.save_profile_btn.pull-right
              dropdown.col-md-12.no_pad
                button.col-sm-12.col-md-12.col-lg-12.btn.btn-primary.dropdown-toggle(slot='button' type='button')
                  i.fa.fa-save.fa-lg
                  &nbsp;
                  span.caret
                ul.dropdown-menu(slot='dropdown-menu')
                  li(v-for='(key, opt) in profileOptions')
                    a(v-on:click='saveProfile(opt.value)') {{opt.label}}
        section.layout_content.clearfix
          section.screen_section.col-xs-8.col-sm-7.col-md-7.col-lg-8.no_pad.clearfix
            .col-lg-12.col-md-12.no_pad-xs.clearfix
              v-screen(
                v-bind:editable='true'
                v-bind:show-link='false'
                v-bind:in-which-page="'layout'"
                v-bind:show-ps-out="true"
                v-bind:show-ps-in="true"
              )
          section.function_section.col-xs-4.col-sm-5.col-md-5.col-lg-4.clearfix.no_pad-xxs
            .col-xs-12.col-md-12.full_screen_btn_group.col-centered.clearfix.no_pad-xxs.no_pad-xs
              header.row_space--xxs.hidden-xs
                label Output
              .col-xs-3.col-sm-3.col-md-3.full__btn__single.clearfix(v-for='key in outputPorts')
                button.btn.btn-default.clearfix.btn-square-xs.no_pad-xs.no_pad-xxs(
                  v-on:click="toFocus(key)"
                  v-bind:class="{active: windowFocus === key}")
                  | {{key}}
              .input_detail.col-xs-12.clearfix.no_pad-xs
                .col-xs-6.col-md-6.h_start
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits[windowFocus][0]" v-on:change="onInputChange(0)")
                .col-xs-6.col-md-6.h_end
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits[windowFocus][2]" v-on:change="onInputChange(2)")
                .col-xs-6.col-md-6.v_start
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits[windowFocus][1]" v-on:change="onInputChange(1)")
                .col-xs-6.col-md-6.v_end
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits[windowFocus][3]" v-on:change="onInputChange(3)")
      modal.change_confirm(
        backdrop='false'
        title='Changes detected'
        v-bind:show.sync='showChgConfirm')
        .modal-header(slot='modal-header')
          button.close(v-on:click='stop')
            span x
          h4.modal-title
            | Changes detected
        .modal-body(slot='modal-body').clearfix
          .col-md-12
            span Save the change as Custome Preset?
          hr
          .col-md-12.saveTo
            label.pull-left Save to
            v-select.pull-left(v-bind:options='profileOptions' v-bind:value.sync='saveToPreset')
        .modal-footer(slot='modal-footer').clearfix
          button.btn.btn-default(v-on:click='leavePage')
            | No
          button.btn.btn-primary(v-on:click='applyCurrentChange')
            | Save
</template>
<script>
import vwScreen from '../../components/VWScreen.vue'
import { mapGetters } from 'vuex'
import Loader from '../../components/Loader.vue'
import { dropdown, modal } from 'vue-strap'
import { call } from '../../Service'
import singleSelect from 'src/components/Single-Select.vue'
import _ from 'lodash'

function numberify (split) {
  for (let windowIndex in split) {
    for (let cordsIndex in split[windowIndex]) {
      split[windowIndex][cordsIndex] = parseInt(split[windowIndex][cordsIndex])
    }
  }
  return split
}

export default {
  components: {
    dropdown,
    modal,
    'v-screen': vwScreen,
    'v-loader': Loader,
    'v-select': singleSelect
  },
  data () {
    return {
      showChgConfirm: false,
      leavePage: () => {},
      applyCurrentChange: () => {},
      stop: () => {},
      saveToPreset: '1'
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    this.$store.dispatch('fetchData', mac)
  },
  computed: {
    ...mapGetters({
      isFetching: 'getIsFetching',
      is4K: 'getIsInput4k',
      outputPorts: 'getOutputPorts',
      windowFocus: 'getWindowFocus',
      splits: 'getSplitArea',
      profiles: 'getProfiles',
      isLayoutChanged: 'getLayoutChanged',
      isMobile: 'getIsMobile',
      inRatio: 'getInRatio'
    }),
    profileOptions () {
      let opts = []
      for (let profile in this.profiles) {
        opts.push({
          label: this.profiles[profile].name,
          value: profile
        })
      }
      return opts
    },
    showMask () {
      return this.isMobile && window.innerWidth < window.innerHeight
    }
  },
  methods: {
    toFocus (windowFocus) {
      this.$store.commit('UPDATE', {type: 'winFocus', windowFocus})
    },
    addListener () {
      // this.$store.commit('UPDATE', {
      //   type: 'isMobile'
      // })
      // this.$store.commit('UPDATE', {
      //   type: 'inRatio'
      // })
      this.$store.dispatch('updateMainScreenSize')
      this.$broadcast('render', '1')
    },
    saveProfile (key) {
      console.log(key)
      let { mac } = this.$route.params
      call(mac, 'dxSetProfileByKey', {profiles: key}).then(res => {
        console.log(res)
        this.$store.commit('UPDATE', {
          type: 'layoutChanged',
          isLayoutChanged: false
        })
      }).catch(err => {
        this.alert('danger', '', err)
      })
    },
    onInputChange (index) {
      let split = _.cloneDeep(this.splits)
      switch (index) {
        case 0:
          if (parseInt(split[this.windowFocus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0')
          break
        case 2:
          if (split[this.windowFocus][0] >= parseInt(split[this.windowFocus][2]) || parseInt(split[this.windowFocus][index]) > this.inRatio[0] * this.inRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen width')
          break
        case 1:
          if (parseInt(split[this.windowFocus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0')
          break
        case 3:
          if (split[this.windowFocus][1] >= parseInt(split[this.windowFocus][3]) || parseInt(split[this.windowFocus][index]) > this.inRatio[1] * this.inRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen height')
          break
      }
      split[this.windowFocus][index] = Number(split[this.windowFocus][index])

      if (this.is4K) {
        this.$store.commit('check4KLimit', {
          index: this.windowFocus
        })
      }

      this.$store.commit('UPDATE', {
        type: 'layoutChanged',
        isLayoutChanged: true
      })

      split = numberify(split)
      call(this.$route.params.mac, 'dxSetSplitArea', {
        split: {
          [this.windowFocus]: split[this.windowFocus]
        }
      }).then(res => {
        console.log(res)
      }).catch(err => {
        console.error(err)
      })
    }
  }, // close methods
  ready () {
    window.addEventListener('orientationchange', this.addListener, false)
    window.addEventListener('resize', this.addListener, false)
  },
  beforeDestroy () {
    window.removeEventListener('orientationchange', this.addListener, false)
    window.removeEventListener('resize', this.addListener, false)
  },
  watch: {
    isFetching (nv) {
      if (!nv) this.addListener()
    },
    is4K (nv) {
      console.log('is4k to ', nv)
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      switch (type) {
        case 'split':
          console.log('event', event)
          this.outLayout = 'init'
          this.$store.commit('UPDATE', {
            type: 'split',
            splitArea: {
              split: event
            }
          })

          setTimeout(() => {
            this.addListener()
            this.buttonDisabled = false
          }, 700)
          break
        case 'resolution':
          this.buttonDisabled = true
          // this.outResolution = event['1']
          if (event.input) {
            this.$store.commit('UPDATE', {type: 'inResolution', resolution: event.input})
            this.$store.commit('UPDATE', {type: 'inRatio'})
            this.addListener()
          }

          if (event.output) {
            this.$store.commit('UPDATE', {
              type: 'outResolutions',
              resolution: event.output
            })
          }

          setTimeout(() => {
            this.buttonDisabled = false
          }, 700)
          break
        case 'preset':
          this.$store.commit('UPDATE', {
            type: 'preset',
            preset: event
          })
          break
      }
    }
  },
  route: {
    deactivate (transition) {
      console.log(transition)
      let vue = this
      window.removeEventListener('orientationchange', this.addListener, false)
      window.removeEventListener('resize', this.addListener, false)
      if (!this.isLayoutChanged) {
        transition.next()
      } else {
        return new Promise(function (resolve, reject) {
          vue.showChgConfirm = true
          vue.leavePage = () => {
            vue.$store.commit('UPDATE', {
              type: 'layoutChanged',
              isLayoutChanged: false
            })
            resolve()
          }
          vue.applyCurrentChange = async () => {
            vue.saveProfile(vue.saveToPreset)
            resolve()
          }
          vue.stop = () => {
            reject()
            vue.showChgConfirm = false
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

.full_screen_btn_group{
  & .full__btn__single{
    & .btn {
      color: $base_black;
      font-weight: bold;
      font-size: 18px;
    }
    &:nth-of-type(1){
      .btn {
        background-color: $window_a;
        &.active {
          background-color: darken($window_a, 10%);
          color: $base_white;
        }
      }

    }
    &:nth-of-type(2){
      .btn {
        background-color: $window_b;
        &.active {
          background-color: darken($window_b, 10%);
          color: $base_white;
        }
      }
    }
    &:nth-of-type(3){
      .btn {
        background-color: $window_c;
        &.active {
          background-color: darken($window_c, 10%);
          color: $base_white;
        }
      }
    }
    &:nth-of-type(4){
      .btn {
        background-color: $window_d;
        &.active {
          background-color: darken($window_d, 10%);
          color: $base_white;
        }
      }
    }

    @include breakpoint(xs) {

    }
  }
}

.function_section{
  padding-top: $space_sm;
  @include breakpoint(landFive) {
    border-top: 1px solid $pri_gray;
    padding-top: $space_sm;
  }
  @include breakpoint(landSix) {
    padding-top: $space_xs;
  }
}

.screen_section {
  padding-top: $space_sm;

  @include breakpoint(landFive) {
    padding-top: 5px;
  }

  @include breakpoint(landSix) {
    padding-top: $space_xs;
  }

  @include breakpoint(landSixPlus) {
    padding-top: $space_xs;
  }
}

.input_detail{
  padding-top: $space_sm;
  margin-left: auto;
  margin-right: auto;
  padding-left: 25px;
  padding-right: 0px;
  @include breakpoint(landFive) {
    padding-top: $space_xs;
    padding-bottom: $space_md;
  }
  @include breakpoint(landSix) {
    padding-top: $space_xs;
    padding-bottom: $space_md;
  }
  & label{
    font-size: 12px;
  }
  & .form-control{
    padding: 7px 5px;
    text-align: center;
    transition: all .3s;
    transform: scale(0.7,0.7);
    transform-origin: 0 0;
    &:focus{
      transform: scale(.85, .9)
    }
  }
  & .h_start::before{
    content: 'H:';
  }
  & .h_end::before, .v_end::before{
    content: 'to';
    margin-left: -9px;
  }
  & .v_start::before{
    content: 'V:';
  }

  & .h_start, .h_end, .v_start, .v_end{
    position: relative;
    padding-left: 20px;
    padding-right: 0px;
    &::before{
      position: absolute;
      display: block;
      left: 0px;
      top: 0;
    }
    & .form-control{
      padding: 3px;
    }
  }
}

.function_group{
  position: fixed;
  z-index: 50;
  right: 15px;
  margin-top: -7px;
  @include breakpoint(landFive) {
    padding-top: 12px;
  }
  @include breakpoint(landSix) {
    padding-top: 13px;
  }
  @include breakpoint(landSixPlus) {
    padding-top: 14px;
  }
  & .function__single {
    text-align: center;
  }
  & .function__single .btn {
    @include breakpoint(landFive) {
      margin-top: 0px;
      padding: 3px 7px;
    }
    @include breakpoint(landSix) {
      margin-top: 0px;
      padding: 3px 7px;
    }
    @include breakpoint(landSixPlus) {
      margin-top: 0px;
      padding: 3px 7px;
    }
  }
}

.function__single{
  .btn-primary{
    color: $base_white;
  }
  .btn{
    margin-top: 14px;
  }
  &.save_profile_btn{
    .caret{
      margin-right: -6px;
      margin-left: 4px;
    }
    .dropdown-menu{
      left: -80%;
    }
  }
}

/* default style is in _button.scss*/
.btn-square-xs{
  width: 35px;
  height: 35px;
  @include breakpoint(sm) {
    width: 55px;
    height: 55px;
  }

  @include breakpoint(md) {
    width: 55px;
    height: 55px;
  }

  @include breakpoint(lg) {
    width: 55px;
    height: 55px;
  }
}

.mask{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  left: 0;
  top: 0;
  text-align: center;
  line-height: 100%;
  background-color: $base-black;
  color: $base-white;
  & h2{
    position: fixed;
    margin-top: 30%;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    color: #fff;
  }
  @include breakpoint(landXS) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Layout.vue?3cc822a9